/*jshint ignore:start*/
(function() {
    angular.module('invesfleet')
        .directive('reportingCloseElements',
            function($document) {
                return {
                    restrict: 'A',
                    link: function(scope, elem, attr) {
                        elem.on('click',
                            function(e) {
                                $("[reporting-stop-propagation]").hide();
                            });
                    }
                }
            });
}());
/*jshint ignore:end*/